import { Navigate, Route, Routes } from 'react-router-dom';
import EcommerceDashboardPage from './EcommerceDashboardPage';
import ProductsPage from './ProductsPage';
import OrdersPage from './OrdersPage';
import CustomersPage from './CustomersPage';

export default function EcommerceRoutes() {
  return (
    <Routes>
      <Route index element={<EcommerceDashboardPage />} />
      <Route path="products" element={<ProductsPage />} />
      <Route path="orders" element={<OrdersPage />} />
      <Route path="customers" element={<CustomersPage />} />
      <Route path="*" element={<Navigate to="." replace />} />
    </Routes>
  );
}
